/**
 * Animate newsletter button the The Latest page
 */
let buttonState = false;

const newsletterButton = () => {
  const button = document.querySelector('.maillist');
  if (!button) return;
  document.addEventListener('click', (e) => {
    if (e.target.closest('.maillist')) {
      if (buttonState) {
        setTimeout(() => {
          button.classList.add('maillist--active');
        }, 10000);
        buttonState = false;
      } else {
        button.classList.remove('maillist--active');
        buttonState = true;
      }
    }
  });
};

export const theLatest = () => {
  newsletterButton();
};
